import http from './httpServices';

const VideoIntegrationService = {
  getStatus: () => http.get('/integrations/status'),

  // YouTube
  getYouTubeAuthUrl: () => http.get('/integrations/youtube/auth'),
  disconnectYouTube: () => http.post('/integrations/youtube/disconnect'),

  // Vimeo
  getVimeoAuthUrl: () => http.get('/integrations/vimeo/auth'),
  disconnectVimeo: () => http.post('/integrations/vimeo/disconnect'),

  // Settings
  updateSettings: (data) => http.post('/integrations/settings', data),

  // Upload
  triggerUpload: (recordingId, platform, privacy) =>
    http.post(`/integrations/upload/${recordingId}`, { platform, privacy }),

  getUploadStatus: (recordingId) =>
    http.get(`/integrations/upload-status/${recordingId}`),
};

export default VideoIntegrationService;
